import Item from 'common/ITEMS/Item';

const items = {
  //region Balance
  //endregion
  //region Feral
  //endregion
  //region Guardian
  //endregion
  //region Restoration
  //endregion
  //region Shared
  //endregion
} satisfies Record<string, Item>;
export default items;
